import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { createApi } from './tackle_box';
import * as rawTagTypes from './tag_types';

const tagTypes = Object.values(rawTagTypes);

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({ baseUrl: '' }),
  tagTypes,
  endpoints: () => ({}),
});
